import {
  getProviderAccessState,
  type ProviderAccessState,
} from "@/app/api/provider/accessState";

export type ProviderDestination =
  | "/dashboard"
  | "/register/beta"
  | "/register/onboarding"
  | "/register/checkout"
  | "/error/disabled";

export const destinationFromProviderState = (
  state: ProviderAccessState,
  registrationFlow: "LEGACY" | "SELF_SERVICE",
): ProviderDestination => {
  if (registrationFlow !== "LEGACY" && registrationFlow !== "SELF_SERVICE") {
    throw new Error("Unknown provider registration flow.");
  }
  switch (state) {
    case "ACTIVE":
      return "/dashboard";
    case "NEEDS_ONBOARDING":
      return registrationFlow === "SELF_SERVICE"
        ? "/register/onboarding"
        : "/register/beta";
    case "NEEDS_ENTITLEMENT":
      if (registrationFlow !== "SELF_SERVICE") {
        throw new Error("Legacy billing requires separate routing.");
      }
      return "/register/checkout";
    case "DISABLED":
      return "/error/disabled";
    default:
      throw new Error("Unknown provider access state.");
  }
};

export const getProviderPostAuthDestination =
  async (): Promise<ProviderDestination> => {
    const response = await getProviderAccessState();

    if (response.status !== "success") {
      throw new Error("Unable to verify provider access.");
    }

    return destinationFromProviderState(
      response.data.accessState,
      response.data.registrationFlow,
    );
  };
